export const state = {
    lancamentoBancario: {
        numero_documento: "",
        data_lancamento: "",
        data_competencia: "",
        historico: "",
        portador_id: "",
        grupo_id: "",
        banco_id: "",
        valor: "",
        tipo: "",
        contato_id: "",
        anexo: "",
        empresa_id: "",
    },
    lancamentosBancarios: [],
    modalExcluirLancamentoBancario: false,
    modalCadastroLancamentoBancario: false,
    showInputAnexoLancamentoBancario: true
}

export default {}